import PropTypes from 'prop-types';
import Tooltip from '@/components/core/Tooltip';

const BETA_TEXT =
  'Sesame AI is in beta and can make mistakes: it may pick a different module than you would, ' +
  'misread a value, or misstate a result. Check the pathway, key assumptions and results before ' +
  'relying on them, and use Report Bug if something looks wrong.';

const BetaBadge = ({ className = '' }) => (
  <Tooltip label="Beta" text={BETA_TEXT}>
    <span
      className={`text-[10px] font-medium uppercase tracking-wide px-1.5 py-0.5 rounded border cursor-default select-none ${className}`}
    >
      Beta
    </span>
  </Tooltip>
);

BetaBadge.propTypes = {
  className: PropTypes.string,
};

export default BetaBadge;
